import { render, staticRenderFns } from "./product_setting_items.vue?vue&type=template&id=dd0b85f4&scoped=true&"
import script from "./product_setting_items.vue?vue&type=script&lang=js&"
export * from "./product_setting_items.vue?vue&type=script&lang=js&"
import style0 from "./product_setting_items.vue?vue&type=style&index=0&id=dd0b85f4&lang=scss&scoped=true&"
import style1 from "./product_setting_items.vue?vue&type=style&index=1&id=dd0b85f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0b85f4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VSlider,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dd0b85f4', component.options)
    } else {
      api.reload('dd0b85f4', component.options)
    }
    module.hot.accept("./product_setting_items.vue?vue&type=template&id=dd0b85f4&scoped=true&", function () {
      api.rerender('dd0b85f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/render_custom_plugin/product_setting_items.vue"
export default component.exports